<template>
    <DsAvatarBase
        :config="{
            type: 'initials',
            size,
            firstName,
            lastName,
        }"
    />
</template>

<script setup lang="ts">
import type { InitialsAvatarProps } from './DsAvatarBase.vue';
import DsAvatarBase from './DsAvatarBase.vue';

withDefaults(defineProps<Omit<InitialsAvatarProps, 'type'>>(), {
    lastName: '',
});
</script>
